import React, { useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import MenuItem from "@material-ui/core/MenuItem";
import { FormControl, Select, InputLabel } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { RightSideCountTop } from "../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { serverApi } from "../../../../config/Keys";
import isEmpty from "../../../../store/validation/is-Empty";
import SelectFilter from "../../../reusableComponents/selectFilter";
import TodayDateTime from "../../../reusableComponents/AllDateComponents/TodayDateTime";
import moment from "moment";
import { ORDER_TYPE, ORDER_TYPE_NAME } from "../../../../enums/OrderEnums";
import MainFilterSection from "../../../reusableComponents/searchandfilters/MainFilterSection";

const SuperAdminInvoice = ({ ...props }) => {
  const [reportData, setReportData] = useState([]);
  const [reportStat, setReportStat] = useState({});
  const [search, setSearch] = useState("");
  const [dateQuery, setDateQuery] = useState({});
  const [rangeType, setRangeType] = useState("Today");

  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      getReportData("", dateQuery);
    }
  }, [auth]);

  const getReportData = async (type, dateQuery) => {
    let data = await axios.get(`${serverApi}/admin/transactionalReport`, {
      params: { reportType: type, ...dateQuery },
      headers: {
        Authorization: auth.accessToken,
        "Content-Type": "application/json",
      },
    });
    if (data.data) {
      setReportData(data?.data?.report || []);
      setReportStat(data?.data?.stats?.[0] || {});
    }
  };

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
    setRangeType(type);
    getReportData("", data);
  };

  const renderData = reportData.filter((item) => {
    return (
      item?.restaurant_id?.restaurant_name
        .toLowerCase()
        .includes(search.toLowerCase()) ||
      item?.restaurant_id?.area.toLowerCase().includes(search.toLowerCase())
    );
  });

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Reports" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div>
                  <div className="f24_700_HelveticaNeue">Invoice Report</div>
                  <div className="f12-400">Here you can view the list of invoices for multiple request types</div>
                </div>
                <TodayDateTime />
              </div>
              <div className="d-flex justify-content-end align-items-end">
                {/* <MainFilterSection /> */}
                <div>
                  <RightSideCountTop
                    content={[
                      {
                        name: "Total Amount",
                        value: `₹ ${reportStat?.totalAmount
                          ? (reportStat?.totalAmount)
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                          : 0
                          }`,
                        backgroundColor: "#FFEDE9",
                        color: "#EE3A23",
                      },
                      {
                        name: "Total Transactions",
                        value: `${reportStat?.count || 0}`,
                        backgroundColor: "#D8F3F4",
                        color: "#138B90",
                      },
                    ]}
                  />
                  <SelectFilter onDateChange={onDateChangeHandler()} defaultSelected="TODAY" />
                </div>
              </div>


              <div>
                <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                  <Table className="HideShowTable enMinWidth900">
                    <thead>
                      <tr className="super_admin_all_users_table_head">
                        <th style={{ width: "8%" }} className="f12-700">
                          Invoice Id
                        </th>
                        <th style={{ width: "20%" }} className="f12-700">
                          Business <br />
                          Name/ID
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          User
                        </th>
                        <th style={{ width: "14%" }} className="f12-700">
                          Request Type / Request ID
                        </th>
                        <th style={{ width: "12%" }} className="f12-700">
                          Invoice Data & Time
                        </th>
                        <th style={{ width: "15%" }} className="f12-700">
                          Order Total
                        </th>
                        <th style={{ width: "15%" }} className="f12-700">
                          Payment Status
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    {renderData &&
                      renderData.map((data) => (
                        <tbody>
                          <tr className="super_admin_all_users_table_body">
                            <td style={{ width: "8%" }} >
                              <div className="f12-500">{data?.transactionNumber || data?._id}</div>
                            </td>
                            <td style={{ width: "20%" }} className="f12-500">
                              <div className="super-admin-suggestion-table-body-boxone d-flex align-items-center">
                                <div className="super-admin-suggestion-imageBoxTwo ml-2">
                                  <div className="f12-500">
                                    {data?.restaurant_id?.restaurant_name || ""}{" "}
                                    <br />
                                    {data?.restaurant_id?.area || ""}
                                    <br />
                                    {data?.restaurant_id?._id || ""}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td style={{ width: "10%" }}>
                              <div className="f12-500">{data?.user_id?.first_name || ""} {data?.user_id?.last_name || ""}</div>
                            </td>
                            <td style={{ width: "14%" }} className="f12-500">
                              <div className="f12-500">{(data?.orderId && data?.order_type) ? ORDER_TYPE_NAME[data?.order_type]
                                : data?.transaction_type === 'SCAN_AND_PAY' ? data?.transactionNumber
                                  : data?.expRequestId ? data?.expRequestId?.experienceId?.subCategory?.title : ""
                              }</div>
                              <br />
                              <div className="f12-500">
                                {(data?.orderId) ? data?.orderId?.order_id
                                  : data?.transaction_type === 'SCAN_AND_PAY' ? data?.transactionNumber
                                    : data?.expRequestId ? data?.expRequestId?.requestId : ""
                                }
                              </div>
                            </td>
                            <td style={{ width: "12%" }} className="f12-500">
                              <div className="f12-500">{moment(data?.updatedAt).format('LL')}</div>
                              <div className="f12-500">{moment(data?.updatedAt).format('LT')}</div>
                            </td>
                            <td style={{ width: "15%" }} className="f12-500">
                              <div className="f12-500">{`₹ ${data?.amount
                                ? (data?.amount)
                                  .toFixed(2)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                                : 0
                                }`}</div>
                            </td>
                            <td style={{ width: "15%" }} className="f12-500">
                              <div className="badge badge-success">Paid</div>
                            </td>
                            <td style={{ width: "10%" }}>

                            </td>
                          </tr>
                        </tbody>
                      ))}
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SuperAdminInvoice;
